import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchBodyTypeMutation } from '../../../services'
import { UspConfigurationCarBodyTypeViewResult } from '../../../models'
import InventoryBodyTypesTable from './components/InventoryBodyTypesTable'
import AddEditBodyTypeModal from './components/AddEditBodyTypeModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsInventoryBodyTypes = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCarBodyType, { data, isLoading }] = useSearchBodyTypeMutation()
  const [carBodyTypeData, setCarBodyTypeData] = useState<UspConfigurationCarBodyTypeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchCarBodyType({
      uspConfigurationCarBodyTypeView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarBodyTypeData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Body Types'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='Body Types' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryBodyTypesTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={carBodyTypeData}
                      setData={setCarBodyTypeData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditBodyTypeModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarBodyTypeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryBodyTypes
